// projectSaga.js
import { call, put, takeLatest } from 'redux-saga/effects';

import { PROJECT_DETAILS_FAILURE, PROJECT_DETAILS_REQUEST, PROJECT_DETAILS_SUCCESS } from '../Actions/Actions';
import Axios from '../../utils/Axios';
import AuthHandler from '../../utils/AuthHandler';
import { navigate } from '../../utils/navigation';
import { PROJECT_DETAILS_PID } from '../../config/API_Collection';
import { getErrorMessage } from '../../config/Error_Codes';



function* fetchProjectDetailsSaga({payload}) {
  try {
    const response = yield call(Axios.get,`${PROJECT_DETAILS_PID}${payload}`);
  
    
    const projects = response.data.data || [];
    yield put({type:PROJECT_DETAILS_SUCCESS,payload:projects});
  } catch (error) {
    yield call(AuthHandler, error.response?.status, null, navigate);
    yield put({type:PROJECT_DETAILS_FAILURE,payload:getErrorMessage(error.status)});
  }
}

export default function* projectDetailsSagas() {
  yield takeLatest(PROJECT_DETAILS_REQUEST, fetchProjectDetailsSaga);
}
